import { api } from '@/lib/api';
import { ApiResponse } from '@/types/types';

export type AppointmentPrescriptionSummary = {
  appointmentId: string;
  hasDiagnosis: boolean;
  hasPrescription: boolean;
  prescriptionId: string | null;
  prescriptionNumber: string | null;
  medicinesCount: number;
};

export const prescriptionApi = {
  getByAppointment: (appointmentId: string) =>
    api
      .get<ApiResponse<AppointmentPrescriptionSummary>>(
        `/api/prescription/appointments/${appointmentId}/prescription`
      )
      .then((r) => r.data.data),

  openPdf: (prescriptionId: string) =>
    `/api/prescription/prescriptions/${prescriptionId}/download-pdf`,

  diagnosisPdfUrl: (appointmentId: string) =>
    `/api/diagnosis/download-pdf/${appointmentId}`,
};
